<template>
  <div :id="blockId" :style="blockStyle" class="element-editor emoji-editor">
    <svg width="100%" :viewBox="viewBox" :class="animateClass">
      <text

        :x="xCoord"
        :y="yCoord"
      >{{ emoji.native }}</text>
    </svg>
  </div>
</template>

<script>
import utils from '@/util'

const isApplePlatform = utils.getOS() === 'MacOS'
export default {
  name: 'EmojiEditor',
  props: {
    emoji: {
      type: Object,
      default: null,
    },
    blockId: {
      type: String,
      default: null,
    },
    blockStyle: {
      type: Object,
      default: null,
    },
    animation: {
      type: String,
      default: '',
    },
    isInfinity: {
      type: Boolean,
      default: false,
    },
    duration: {
      type: Number,
      default: 0,
    },
  },
  computed: {
    animateClass() {
      if (!this.animation) return null
      return `animate__animated animate__${this.animation} ${this.isInfinity ? 'animate__infinite' : ''} ${this.duration ? `animate__delay-${this.duration}s` : ''} `
    },
    viewBox() {
      if (isApplePlatform) {
        return '0 0 36 36'
      }
      return '0 0 42 42'
    },
    xCoord() {
      if (isApplePlatform) {
        return '0%'
      }
      return '-10%'
    },
    yCoord() {
      if (isApplePlatform) {
        return '86%'
      }
      return '80%'
    },
  },
  mounted() {
    this.$nextTick(() => { this.$emit('ready') })
  },
}
</script>

<style lang="scss" scoped>
.emoji-content {
  font-size: 10vw;
  height: 100%;
}
</style>
